import React from 'react';
import './App.css';
import Login from './features/login/login';

function App() {
  return (
    <Login />
  );
}

export default App;
